<template>
  <v-card class="d-flex align-center justify-center pa-5" min-width="30vw" outlined>
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-list-item class="d-flex align-center justify-start text-center ">
          <v-list-item-title>
            <h1 style="color: #00f784">{{ title }} <v-icon color="#00f784" class="ml-2 mt-n1" large>fa-grin-stars</v-icon></h1>
          </v-list-item-title>
          <v-spacer/>
          <v-list-item-action><v-icon class="icon" @click="close" icon>fa-times</v-icon></v-list-item-action>
        </v-list-item>
      </v-row>
      <v-row class="d-flex align-center justify-center mt-5">
        <p  class="mb-0">{{ $t('hurryUp') }}</p>
        <Counter class="justify-center" :end-time="endTime" />
      </v-row>
      <v-row align="center" justify="center">
        <v-col v-bind:key="promo.title" v-for="promo in promos" cols="6">
          <v-card class="card-promo pa-5 text-center">
            <h2>{{ promo.title }}</h2>
            <h1 style="color: #00f784;">{{ promo.discount }} {{ $t('discount') }}</h1>
            <p class="mb-1 mt-3">{{ $t('finalPrice',{price:promo.price}) }}</p>
            <v-btn class="button-promo mt-3" @click="getNow(promo)">{{ $t('getNow') }}</v-btn>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import Counter from "@/components/Counter";

export default {
  name: "BigPromo",
  props: {
    title: String,
    endTime: Date,
  },
  components: {Counter},
  data() {
    return {
      promos: [
        { title: 'Pro Lifetime', discount: '50%', price: '125', callToAction: 'https://api.whatsapp.com/send?phone=573217956013&text=I%20want%20the%20Black%20Friday%20Promo!%20' },
        //{ title: 'Pro Annually', discount: '21%', price: '99', callToAction: 'https://app.swiset.com/subscription-plans' },
      ],
    };
  },
  methods: {
    getNow(promo) {
      if(promo.title === 'Pro Annually')
        this.$router.push('/subscription-plans');
      else if(promo.title === 'Pro Lifetime' && this.$store.state.user.details.country === 'Colombia')
        window.open('https://payco.link/722600');
      else
        window.open('https://paypal.me/swiset');
    },
    close() {
      this.$emit('closeWindow');
    },
  }
}
</script>

<style scoped>
</style>



